// ======================================================================
// File: PRTimeline.jsx
// Module: PPE → Procurement → Purchase Request
//
// Purpose:
// - Display Purchase Request lifecycle history
// - Read-only audit trail
// ======================================================================

import React from "react";

export default function PRTimeline({ history = [] }) {
  if (!history || history.length === 0) {
    return (
      <div className="erp-timeline-empty">
        No activity history available
      </div>
    );
  }

  return (
    <div className="erp-timeline">
      <h4>Purchase Request History</h4>

      <ul>
        {history.map((item, index) => (
          <li key={index}>
            <div className="timeline-dot" />

            <div className="timeline-content">
              <strong>{item.action}</strong>

              <div>
                By: {item.performed_by || "System"}
              </div>

              <div className="timeline-date">
                {item.performed_at}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
